import { MAX_LIST_VISIBLE_INDENTATION, normalizeOffset } from "./../../../../../wix-rich-content-common";
function getStartMargin(parentNode, visibleIndentation) {
  if (!parentNode) {
    return "1.5em";
  }
  const parenNodeDataName = `${parentNode?.type?.slice(0, -5).toLowerCase()}ListData`;
  const nodeOffset = parentNode[parenNodeDataName]?.offset || 0;
  const offset = visibleIndentation > MAX_LIST_VISIBLE_INDENTATION ? nodeOffset - (visibleIndentation - MAX_LIST_VISIBLE_INDENTATION) : normalizeOffset(nodeOffset);
  return parentNode ? `${normalizeOffset(offset) * 2 + 1.5}em` : "";
}
export {
  getStartMargin
};
//# sourceMappingURL=getStartMargin.js.map
